import { render } from "./Research.vue?vue&type=template&id=3fcb81ba&scoped=true&ts=true"
import script from "./Research.vue?vue&type=script&lang=ts"
export * from "./Research.vue?vue&type=script&lang=ts"

import "./Research.vue?vue&type=style&index=0&id=3fcb81ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcb81ba"]])

export default __exports__